/**
 * LERA PI Purchase — Sprint 8.5A.1
 * Visual micro-interactions only (quantity fade, ATC/Buy Now loading labels).
 * Does not alter Shopify product-form submit / AJAX / cart logic.
 */

(function () {
  const ROOT = '.lera-pi-purchase';
  const PULSE = 'lera-qty__input--pulse';
  const DUR = 180;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function enhanceQuantity(root) {
    const input = root.querySelector('.lera-qty .quantity__input, quantity-input.lera-qty .quantity__input');
    if (!input || input.dataset.leraQtyBound === '1') return;
    input.dataset.leraQtyBound = '1';

    let last = input.value;
    const pulse = () => {
      if (prefersReducedMotion()) return;
      input.classList.add(PULSE);
      window.setTimeout(() => input.classList.remove(PULSE), DUR);
    };

    input.addEventListener('change', () => {
      if (input.value !== last) {
        last = input.value;
        pulse();
      }
    });

    root.querySelectorAll('.lera-qty .quantity__button').forEach((btn) => {
      btn.addEventListener('click', () => {
        window.requestAnimationFrame(() => {
          if (input.value !== last) {
            last = input.value;
            pulse();
          }
        });
      });
    });
  }

  function enhanceAddToCart(root) {
    const btn = root.querySelector('.product-form__submit.lera-atc, .lera-atc.product-form__submit');
    if (!btn || btn.dataset.leraAtcBound === '1') return;
    btn.dataset.leraAtcBound = '1';

    const label =
      btn.querySelector('[data-lera-atc-label]') ||
      btn.querySelector('span:not(.lera-atc__icon):not(.loading__spinner):not(.loading-overlay__spinner)');
    if (!label) return;

    const adding =
      root.dataset.leraAdding ||
      btn.dataset.leraAdding ||
      'Adding...';

    const sync = () => {
      if (btn.classList.contains('loading')) {
        if (!btn.dataset.leraAtcLoading) {
          btn.dataset.leraAtcOriginal = label.textContent.trim();
          btn.dataset.leraAtcLoading = '1';
          label.textContent = adding;
        }
      } else if (btn.dataset.leraAtcLoading) {
        label.textContent = btn.dataset.leraAtcOriginal || label.textContent;
        delete btn.dataset.leraAtcLoading;
        delete btn.dataset.leraAtcOriginal;
      }
    };

    const observer = new MutationObserver(sync);
    observer.observe(btn, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });
  }

  function enhanceBuyNow(root) {
    const processing =
      root.dataset.leraProcessing ||
      'Processing...';

    const bindButton = (btn) => {
      if (!btn || btn.dataset.leraBuyBound === '1') return;
      btn.dataset.leraBuyBound = '1';

      const sync = () => {
        const busy =
          btn.getAttribute('aria-disabled') === 'true' ||
          btn.hasAttribute('disabled') ||
          btn.classList.contains('loading') ||
          btn.getAttribute('aria-busy') === 'true';

        if (busy) {
          if (!btn.dataset.leraBuyLoading) {
            btn.dataset.leraBuyOriginal = btn.textContent.trim();
            btn.dataset.leraBuyLoading = '1';
            btn.classList.add('is-lera-processing');
            btn.textContent = processing;
          }
        } else if (btn.dataset.leraBuyLoading) {
          btn.textContent = btn.dataset.leraBuyOriginal || btn.textContent;
          btn.classList.remove('is-lera-processing');
          delete btn.dataset.leraBuyLoading;
          delete btn.dataset.leraBuyOriginal;
        }
      };

      btn.addEventListener('click', () => {
        // Optimistic processing label while Shopify redirects / processes.
        if (!btn.dataset.leraBuyLoading && !btn.disabled) {
          btn.dataset.leraBuyOriginal = btn.textContent.trim();
          btn.dataset.leraBuyLoading = '1';
          btn.classList.add('is-lera-processing');
          btn.textContent = processing;
        }
      });

      const observer = new MutationObserver(sync);
      observer.observe(btn, {
        attributes: true,
        attributeFilter: ['class', 'disabled', 'aria-disabled', 'aria-busy'],
      });
    };

    const scan = () => {
      root
        .querySelectorAll(
          '.shopify-payment-button__button--unbranded, .shopify-payment-button [role="button"]'
        )
        .forEach(bindButton);
    };

    scan();

    const host = root.querySelector('.shopify-payment-button');
    if (host && host.dataset.leraBuyWatch !== '1') {
      host.dataset.leraBuyWatch = '1';
      const mo = new MutationObserver(scan);
      mo.observe(host, { childList: true, subtree: true });
    }
  }

  function enhance(root) {
    if (!root || root.dataset.leraPurchaseEnhanced === '1') {
      // Re-bind after section morph if needed
      enhanceQuantity(root);
      enhanceAddToCart(root);
      enhanceBuyNow(root);
      return;
    }
    root.dataset.leraPurchaseEnhanced = '1';
    enhanceQuantity(root);
    enhanceAddToCart(root);
    enhanceBuyNow(root);
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('lera:variant:selected', () => requestAnimationFrame(boot));
  document.addEventListener('variant:selected', () => requestAnimationFrame(boot));
})();
